import React, { useState, useEffect, useRef } from "react";
import { GOOGLE_SEARCHABLE_COUNTRY } from "../../../Common/commonMethods";

let autoComplete;

const loadScript = (url, callback) => {
  let script = document.createElement("script");
  script.type = "text/javascript";

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};

const SearchLocationInput = ({ dispatch, match }) => {
  const [query, setQuery] = useState("");
  const autoCompleteRef = useRef(null);

  function handleScriptLoad(updateQuery, autoCompleteRef) {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      {
        componentRestrictions: { country: GOOGLE_SEARCHABLE_COUNTRY },
      }
    );

    autoComplete.addListener("place_changed", () =>
      handlePlaceSelect(updateQuery)
    );
  }

  async function handlePlaceSelect(updateQuery) {
    const addressObject = autoComplete.getPlace();

    const query = addressObject.formatted_address;
    updateQuery(query);

    const latLng = {
      lat: addressObject?.geometry?.location.lat(),
      lng: addressObject?.geometry?.location.lng(),
    };

    dispatch({
      type: "locations/SEARCH_NEAR_LOCATION",
      payload: {
        latitude: latLng.lat,
        longitude: latLng.lng,
        business: match.params.business,
      },
    });
    dispatch({
      type: "locations/SET_MAP_SELECTED_LOCATION",
      payload: { lat: latLng.lat, long: latLng.lng },
    });
  }

  useEffect(() => {
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places`,
      () => handleScriptLoad(setQuery, autoCompleteRef)
    );
  }, []);

  return (
    <div className="search-location-input">
      <label>Type in your suburb or postcode</label>
      <input
        className="form-control"
        ref={autoCompleteRef}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search Places ..."
        value={query}
      />
    </div>
  );
};

export default SearchLocationInput;
